<template>
  <div class="aboutBg searchPagePd60">
    <div class="aboutWrapper">
      <img class="about" src="https://img.ytsg.com/html/userweb/about.jpg" alt="关于我们">
    </div>
  </div>
</template>
<script>
  import {store} from '../store/store';
  import $ from 'jquery';

  export default {
    name: 'about',
    components: {
    }
  }
</script>
<style scoped>
  .aboutBg {
    width: 100%;
    background-size: contain!important;
  }
  .aboutWrapper {
    margin: 0 auto;
    width: 1000px;
  }
  .about {
  }
</style>
